import { TButtonSize } from '@cian/ui-kit/button/types';

interface IParams {
  isSingleButton: boolean;
  isMobile: boolean;
}

export const getButtonSize = (params: IParams): TButtonSize => {
  const { isSingleButton, isMobile } = params;

  switch (true) {
    case !isSingleButton:
      return 'XS';

    case isMobile:
      return 'L';

    default:
      return 'M';
  }
};
